import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id B1E31148-2318-459A-AA91-1C87D306D71A
 * name fridge-variant-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const FridgeVariantOutlineIcon = createSvgIcon(<><path d="M17 2H7C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2M7 19V14H10V10H7V4H11V19H7M17 19H13V4H17V19Z" /></>, 'FridgeVariantOutlineIcon');
export default FridgeVariantOutlineIcon